/**
 * @generated SignedSource<<174cca26c210d6699ef6c14ca8448d63>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssetStakingType = "FLEXIBLE" | "LOCKED";
export type UnstakeAssetAcceptViewQuery$variables = {
  assetId: string;
};
export type UnstakeAssetAcceptViewQuery$data = {
  readonly unstakeAsset: {
    readonly __typename: "StakingOverview";
    readonly items: ReadonlyArray<{
      readonly asset: {
        readonly id: string;
        readonly logoUrl: string | null | undefined;
        readonly name: string | null | undefined;
        readonly portfolio: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly assets: {
                readonly edges: ReadonlyArray<{
                  readonly fiatTotalStakedAmount: PrecisionFloat | null | undefined;
                  readonly stakedBalance: ValueChange | null | undefined;
                } | null | undefined> | null | undefined;
              } | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
          readonly fiatBalance: PrecisionFloat | null | undefined;
        } | null | undefined;
        readonly price: PrecisionFloat | null | undefined;
        readonly staking?: {
          readonly type: AssetStakingType | null | undefined;
          readonly unboundedPeriodInDays: number | null | undefined;
        } | null | undefined;
        readonly symbol: string | null | undefined;
      };
      readonly rewardsAsset: PrecisionFloat;
      readonly rewardsFiat: PrecisionFloat;
      readonly stakedAsset: PrecisionFloat;
      readonly stakedFiat: PrecisionFloat;
    }> | null | undefined;
  } | null | undefined;
};
export type UnstakeAssetAcceptViewQuery = {
  response: UnstakeAssetAcceptViewQuery$data;
  variables: UnstakeAssetAcceptViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "assetId"
  }
],
v1 = [
  {
    "fields": [
      {
        "items": [
          {
            "kind": "Variable",
            "name": "assetIds.0",
            "variableName": "assetId"
          }
        ],
        "kind": "ListValue",
        "name": "assetIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stakedFiat",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stakedAsset",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rewardsFiat",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rewardsAsset",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoUrl",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "AssetPortfoliosConnection",
  "kind": "LinkedField",
  "name": "portfolio",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fiatBalance",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetPortfoliosEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Portfolio",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PortfolioAssetsConnection",
              "kind": "LinkedField",
              "name": "assets",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PortfolioAssetsEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fiatTotalStakedAmount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "stakedBalance",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetStaking",
      "kind": "LinkedField",
      "name": "staking",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unboundedPeriodInDays",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CryptoAsset",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnstakeAssetAcceptViewQuery",
    "selections": [
      {
        "alias": "unstakeAsset",
        "args": (v1/*: any*/),
        "concreteType": "StakingOverview",
        "kind": "LinkedField",
        "name": "stakingOverview",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StakingOverviewItem",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnstakeAssetAcceptViewQuery",
    "selections": [
      {
        "alias": "unstakeAsset",
        "args": (v1/*: any*/),
        "concreteType": "StakingOverview",
        "kind": "LinkedField",
        "name": "stakingOverview",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StakingOverviewItem",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fb572776b6b373cd8a803e88ba540db2",
    "id": null,
    "metadata": {},
    "name": "UnstakeAssetAcceptViewQuery",
    "operationKind": "query",
    "text": "query UnstakeAssetAcceptViewQuery(\n  $assetId: ID!\n) {\n  unstakeAsset: stakingOverview(input: {assetIds: [$assetId]}) {\n    __typename\n    items {\n      stakedFiat\n      stakedAsset\n      rewardsFiat\n      rewardsAsset\n      asset {\n        __typename\n        id\n        name\n        symbol\n        logoUrl\n        price\n        portfolio {\n          fiatBalance\n          edges {\n            node {\n              assets {\n                edges {\n                  fiatTotalStakedAmount\n                  stakedBalance\n                }\n              }\n            }\n          }\n        }\n        ... on CryptoAsset {\n          staking {\n            unboundedPeriodInDays\n            type\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4f423238225df9bc3869483a43d7592e";

export default node;
